import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import { Tabs, Tab } from 'material-ui/Tabs';
import { Redirect } from 'react-router-dom';
import stores from '../../stores';

@inject('translationsStore', 'routesStore', 'configurationsStore', 'oidcStore') @observer
export default class SettingsTabs extends Component {

    state = {
        selectedTabId: -1,
        routeTo: undefined
    };

    handleActive = tab => {
    if (this.props.routesStore.settingsSelectedTabId !== tab.props['value']) {

            this.setState({
                selectedTabId: tab.props['value'],
                routeTo: tab.props['data-route']
            });
        }
    }

    componentDidMount() {
        this.props.configurationsStore.updateStore();

        this.setState({
            selectedTabId: 1,
            routeTo: undefined
        });
    }

    getTabs() {
        var tabs = [];
        const userPermissions = stores.oidcStore.currentUser.profile['access-control-permissions'];

        const { isMultitenancyMode, isDefaultTenant } = this.props.configurationsStore;

        const generalTitle = this.props.translationsStore.translate('GENERAL');
        if (userPermissions.includes('manage-system-settings') && (isMultitenancyMode === false || isDefaultTenant)) {
            tabs.push({
                id: 1,
                title: generalTitle,
                className: 'smtp-tab-button',
                route: '/settings/general',
                cyData: 'general-tab'
            });
        }

        if (userPermissions.includes('manage-authentication-providers')) {

            isMultitenancyMode === false && tabs.push(
                {
                    id: 2,
                    title: 'LDAP',
                    className: 'ldap-tab-button',
                    route: '/settings/ldap',
                    cyData: 'ldap-tab'
                });

            tabs.push({
                id: 3,
                title: 'SAML',
                className: 'saml-tab-button',
                route: '/settings/saml',
                cyData: 'saml-tab'

            });


            isMultitenancyMode === true && tabs.push({
                id: 4,
                title: 'MASTER ACCESS CONTROL',
                className: 'master-ac-tab-button',
                route: '/settings/masterAccessControl',
                cyData: 'master-ac-tab'

            });
        }

        const security = this.props.translationsStore.translate('SECURITY');
        if (userPermissions.includes('manage-system-settings')) {
            tabs.push({
                id: 5,
                title: security,
                className: 'security-tab-button',
                route: '/settings/security',
                cyData: 'security-tab'
            });
        }
        return tabs;
    }


    render() {

        if (this.state.routeTo !== undefined) {

            return <Redirect to={this.state.routeTo} />;
        }

        const { settingsSelectedTabId } = this.props.routesStore;

        const tabStyleProps = {

            buttonStyle: { color: '#372f51' }
        };

        var tabs = this.getTabs();

        return (
            <div>
                <Tabs className='tabs-dialog buttons settings-tabs' contentContainerClassName='tabs-dialog-content-wrapper'>
                    {
                        tabs.map((tab, index) => {
                            return <Tab
                                key={index}
                                {...tabStyleProps}
                                value={tab.id}
                                className={
                                    classNames(
                                        tab.className,
                                        'tab-button',
                                        settingsSelectedTabId === tab.id && 'selected'
                                    )
                                }
                                label={tab.title}
                                data-route={tab.route}
                                onActive={this.handleActive}
                                data-cy={tab.cyData}
                            >
                            </Tab>;
                        })
                    }
                </Tabs>
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./src/components/settings/settingsTabs.jsx